import React from 'react';

function Clients() {
  return (
    <section className="page clients">
      <h2>Our Clients</h2>
      <ul>
        <li>Sinsay</li>
        <li>SistersandSeekers</li>
        <li>Guess</li>
        <li>Urban Monkey</li>
        <li>Minimode</li>
      </ul>
    </section>
  );
}

export default Clients;
